//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, {
  useState,
  useCallback,
  useContext,
  useEffect,
  Fragment,
} from "react";
import { toast } from "react-toastify";
import { useHistory, useLocation } from "react-router";

// custom pages
import { styles } from "./styles";
import promotion from "apis/promotion/promotion";
import Loader from "components/Loader/Loader";
import Context from "context/context";
import { useTranslation } from "react-i18next";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";

const Papa = require("papaparse/papaparse.min.js");
const xlsx = require('xlsx');

const GlobalCss = withStyles({
  "@global": {
    " .MuiDialog-scrollPaper": {},
    ".MuiDialog-paperWidthSm": {
      overflow: "hidden",
      maxWidth: "none",
    },
    " .MuiDialog-paper ": {},
    ".MuiFormLabel-root": {
      color: "black",
    },
  },
})(() => null);

export default function UploadPromotionCriteria() {
  const classes = styles();
  const { i18n, t } = useTranslation();
  const { uploadPromotionCriteriaAPI, getCriteriaRule } = promotion();
  const { state, dispatch } = useContext(Context);
  const location = useLocation();
  const history = useHistory();
  const [states, setstates] = useState({
    columns: [],
    currentYear: "",
    dialog: false,
    data: [],
    existData: [],
    notExistData: [],
    selectedFields: [],
    loading: false,
    loadingModal: false,
    categoryValueExist: [],
    categoryValueCurrent: [],
    criteriaRule: [],
    uploadedData: {},
  });
  const { criteriaRule, uploadedData } = states;

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Promotion Management", "Criteria", "Upload"],
    });
    handleGet();
  }, []);

  // get api func
  const handleGet = async () => {
    try {
      let values;
      values = {
        promotionId: location?.state?.id,
      };
      let res = await getCriteriaRule(values);
      if (res && res?.data && Object.keys(res?.data).length > 0) {
        const obj = res?.data;
        setStates({
          criteriaRule: obj,
        });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  function handleChange(file, category) {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);

      fileReader.onload = (e) => {
        const data = e.target.result;
        const workbook = xlsx.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = xlsx.utils.sheet_to_json(worksheet, { header: 1 });
        let res = json.flat().map(cell => cell.toString());
        resolve(res);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });

    promise.then((d) => {
      setStates({ uploadedData: { ...uploadedData, [category]: d } });
    });
  }

  const handleUploadCSV = async () => {
    try {
      let values = {
        data: uploadedData,
        promotionId: location?.state?.id,
      };
      setStates({ loading: true });
      let res = await uploadPromotionCriteriaAPI(values);
      setStates({ loading: false });
      if (res.type === "SUCCESS") {
        return history.push("/dashboard/upload-criteria-status", {
          obj: res?.uploadStatus,
        });
      } else if (res?.type === "Error" && res?.alreadyexsisit) {
        toast.error(res?.message, {
          toastId: "update-error",
        });
      }
    } catch (err) {
      setStates({ loading: false });
      console.log(err);
    }
  };

  const categoryLabels = {
    product_primary_class_id: "MPC",
    business_unit_code: "GL Cost Center",
    label_class_code: "Label Class Code",
    product_brand_name_code: "Brand",
    loyalty_category_code: "Sales Category",
    product_code: "Product Code",
    order_source_code: "Order Source Code",
    primary_major_class_code: "Primary Major Class Code",
    primary_submajor_class_code: "Primary Submajor Class Code",
    primary_minor_class_code: "Primary Minor Class Code",
    loyalty_id: "Loyalty Id",
    order_promotion_code: "Order Promotion Code",
    order_level_coupon:"Order Level Coupon",
    line_promo_coupon:"Line Promo Coupon",
    promotion: "Promotion",
    equipment_order_number:"Equipment Order Number",
    customer_account_number:"Shipto"

   
  };

  const categoryLabels_CA = {
    product_primary_class_id: "MPC",
    // business_unit_code: "GL Cost Center",
    label_class_code: "Label Class Code",
    product_brand_name_code: "Brand",
    // loyalty_category_code: "Sales Category",
    product_code: "Product Code",
    // order_source_code: "Order Source Code",
    // primary_major_class_code: "Primary Major Class Code",
    // primary_submajor_class_code: "Primary Submajor Class Code",
    // primary_minor_class_code: "Primary Minor Class Code",
    // loyalty_id: "Loyalty Id"
  };

  const handleResetFunction = () => {
    const mpc = document.getElementById("MPC");
    if (mpc) {
      mpc.value = null;
    }
    const costCenter = document.getElementById("GL Cost Center");
    if (costCenter) {
      costCenter.value = null;
    }
    const labelClassCode = document.getElementById("Label Class Code");
    if (labelClassCode) {
      labelClassCode.value = null;
    }
    const brand = document.getElementById("Brand");
    if (brand) {
      brand.value = null;
    }
    const salesCategory = document.getElementById("Sales Category");
    if (salesCategory) {
      salesCategory.value = null;
    }
    const productCode = document.getElementById("Product Code");
    if (productCode) {
      productCode.value = null;
    }
    const orderSourceCode = document.getElementById("Order Source Code");
    if (orderSourceCode) {
      orderSourceCode.value = null;
    }
    const primaryMajorClassCode = document.getElementById("Primary Major Class Code");
    if (primaryMajorClassCode) {
      primaryMajorClassCode.value = null;
    }
    const primarySubMajorClassCode = document.getElementById("Primary Submajor Class Code");
    if (primarySubMajorClassCode) {
      primarySubMajorClassCode.value = null;
    }
    const primaryMinorClassCode = document.getElementById("Primary Minor Class Code");
    if (primaryMinorClassCode) {
      primaryMinorClassCode.value = null;
    }
    const loyaltyId = document.getElementById("Loyalty Id");
    if (loyaltyId) {
      loyaltyId.value = null;
    }
    const promoCode = document.getElementById("Order Promotion Code");
    if (promoCode) {
      promoCode.value = null;
    }
    const promotion = document.getElementById("Promotion");
    if (promotion) {
      promotion.value = null;
    }
    setStates({ uploadedData: {} });
  };

  return (
    <React.Fragment>
      <GlobalCss />
      <div>
        <Grid container spacing={0}>
          <Grid
            item
            xs={12}
            style={{
              textAlign: "center",
              fontSize: 20,
              padding: 10,
              position: "relative",
            }}
          >
            <button
              className={classes.backBtn}
              onClick={() => history.goBack()}
            >
              {t("Back")}
            </button>
            <span style={{ fontWeight: "bold" }}>
              {" "}
              {t("Import Data Promotion Criteria")}
            </span>
          </Grid>
         
            <Grid container spacing={0}>
              {Object.keys(criteriaRule)?.map((cr, i) => (
                <Grid item xs={4} style={{ padding: "20px" }} key={i}>
                  <b>{categoryLabels[cr]}</b> {`(${criteriaRule[cr]})`}: &nbsp;<br />
                  <input
                    id={categoryLabels[cr]}
                    type="file"
                    accept=".xlsx"
                    placeholder="import csv"
                    onChange={(event) => {
                      if (event.target.files[0])
                        handleChange(event.target.files[0], cr);
                    }}
                  />
                </Grid>
              ))}
            </Grid>
         
        
            {/* <Grid container spacing={0}>
              {Object?.keys(categoryLabels_CA)?.map((cr, i) => (
                <Grid item xs={4} style={{ padding: "20px" }} key={i}>
                  <b>{categoryLabels_CA[cr]} :</b> &nbsp;<br />
                  <input
                    id={categoryLabels[cr]}
                    type="file"
                    accept=".xlsx"
                    placeholder="import csv"
                    onChange={(event) => {
                      if (event.target.files[0])
                        handleChange(event.target.files[0], cr);
                    }}
                  />
                </Grid>
              ))}
            </Grid> */}
        
        </Grid>
      </div>

      {<Loader Loading={states?.loading}></Loader>}
      <Grid container spacing={0}>
        <Grid item xs={12} style={{ padding: 20, textAlign: "center" }}>
          {uploadedData && Object.keys(uploadedData).length > 0 && (
            <Fragment>
              <Button
                className={
                  states?.loading
                    ? classes.uploadBtnDisabled
                    : classes.submitBtn
                }
                onClick={handleUploadCSV}
                disabled={states?.loading}
              >
                Upload
              </Button>
              <Button
                className={classes.cancelBtn}
                style={{ marginLeft: 10 }}
                onClick={() => {
                  handleResetFunction();
                }}
              >
                Reset
              </Button>
            </Fragment>
          )}
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
